import styled from "styled-components"

export default styled.span`
  color: ${({theme}) => theme.colors.tertiary.r_400};
  font-size: 10px;
  position: relative;
`
